import type { TimelineElement } from "@/timeline/types";

/**
 * "after": shifts everything AT OR AFTER boundaryTime by `delta` (signed) — negative delta pulls
 * content backward to close a gap (classic "ripple right" on a shrink), positive delta pushes it
 * forward to follow content that grew or moved later (ripple right on a grow/move).
 * "before": shifts everything ENDING AT OR BEFORE boundaryTime by `delta` (signed) — positive
 * delta pushes content forward to close a gap opened on the left (ripple left on a trim),
 * negative delta pulls it backward to follow content that grew or moved earlier (ripple left on
 * a grow/move).
 */
export function rippleShiftElements<TElement extends TimelineElement>({
	elements,
	boundaryTime,
	delta,
	direction,
}: {
	elements: TElement[];
	boundaryTime: number;
	delta: number;
	direction: "after" | "before";
}): TElement[] {
	if (direction === "after") {
		return elements.map((element) =>
			element.startTime >= boundaryTime
				? ({ ...element, startTime: element.startTime + delta } as TElement)
				: element,
		);
	}

	return elements.map((element) =>
		element.startTime + element.duration <= boundaryTime
			? ({ ...element, startTime: element.startTime + delta } as TElement)
			: element,
	);
}
